import { Alert, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'

const CancelShippingAlertView = () => {
  const t = useTranslations()

  return (
    <Alert severity="warning" sx={{ ...styles.alert, ...styles.alertWarning }}>
      <Typography component="p" variant="body2">
        {t('shipping-send-cancel:alert-description')}
      </Typography>
    </Alert>
  )
}

export default CancelShippingAlertView
